'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight } from '@subframe/core';
import { Button } from '@/shared/components/ui';
interface WizardFooterProps {
  onCancelar: () => void;
  onConfirmar: () => void;
  confirmarLabel?: string;
  confirmarDisabled?: boolean;
  confirmarLoading?: boolean;
}
export const WizardFooter = t0 => {
  const $ = _c(11);
  const {
    onCancelar,
    onConfirmar,
    confirmarLabel: t1,
    confirmarDisabled: t2,
    confirmarLoading: t3
  } = t0;
  const confirmarLabel = t1 === undefined ? "Confirmar e avan\xE7ar" : t1;
  const confirmarDisabled = t2 === undefined ? false : t2;
  const confirmarLoading = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== onCancelar) {
    t4 = <Button variant="neutral-secondary" size="medium" onClick={onCancelar}>Cancelar</Button>;
    $[0] = onCancelar;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherArrowRight />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== confirmarDisabled || $[4] !== confirmarLabel || $[5] !== confirmarLoading || $[6] !== onConfirmar) {
    t6 = <Button size="medium" iconRight={t5} disabled={confirmarDisabled} loading={confirmarLoading} onClick={onConfirmar}>{confirmarLabel}</Button>;
    $[3] = confirmarDisabled;
    $[4] = confirmarLabel;
    $[5] = confirmarLoading;
    $[6] = onConfirmar;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="flex items-center justify-between border-t border-solid border-neutral-200 px-6 py-6 md:px-20">{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};